import { ThemeProvider } from '@mui/material'
import PlanExports from '@/ui/screens/PlanExports/PlanExports'
import { theme } from '@/core/theme/theme'
import '@/core/l10n/config'

// Renders the foresight plan-exports screen inline in the legacy app. Leaf screen: needs
// only RTK Query (host <Provider>) + scoped theme/i18n. Preserves the old /plan-exports URL.
const PlanExportsEmbed = () => (
  <ThemeProvider theme={theme}>
    <PlanExports />
  </ThemeProvider>
)

export default PlanExportsEmbed
